import { Component, HostListener, AfterViewInit } from '@angular/core';
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from '../header/header.component';
import { Router } from '@angular/router';
import { ApidataService } from '../apidata.service';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { CommonModule } from '@angular/common';
import { environment, GINConstants } from '../../environments/environments';
import swal from "sweetalert2";
@Component({
  selector: 'app-recheckpaymentplan',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, RecaptchaModule, CommonModule],
  templateUrl: './recheckpaymentplan.component.html',
  styleUrl: './recheckpaymentplan.component.css'
})
export class RecheckpaymentplanComponent {
  selectedplan;
  selectedplanamount;
  price_id;
  profile_id;
  selectedprice_id;
  captchaResponse: string;
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  color = '';
  captchaToken: string | null = null; 
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  constructor( private router: Router, private apidata: ApidataService,){


  }

  ngOnInit() {
    this.onResize();
    window.scrollTo(0,0)
    this.profile_id = localStorage.getItem("profile_id");
 
    this.selectedplan = localStorage.getItem('plan');
    this.selectedplanamount = localStorage.getItem('amount');

    this.selectedprice_id =     localStorage.getItem('price_id')
 

    if (this.selectedplan === 'Monthly'){

    }
  }
  public ngAfterViewInit(): void {
    this.loadTurnstileScript().then(() => this.renderTurnstile());}

  checkUserIdAndRoute(planname, amount, price_id) {

   
 
    localStorage.setItem('plan', planname);
    localStorage.setItem('amount', amount)
    localStorage.setItem('price_id', price_id)
    this.selectedplan = planname;
    this.selectedplanamount = amount;
    this.selectedprice_id = price_id;
     
  }
  selectPlan(planId: string) {
   
    this.selectedplan = planId;
    localStorage.setItem('plan', planId);
  }
  continueforpayment(){

    if(this.profile_id === '1' || this.profile_id == undefined || this.profile_id ==null){
    this.router.navigate(['/signupwithcard'])
    }
    else{
      this.apidata.callpaymentapi(this.profile_id, this.selectedprice_id).subscribe(data =>{
   
      
        if (data.meta.code == 403 || data.response =='You are already subscribed. Please cancel previous subscription before getting new Subscription.'){
        
          this.showAlert(data.response, "");
        }
        else if (data.meta.code === 400) {
     
          this.showAlert(data.response,"");
        }
        else if (data.meta.code === 401) {
       
          this.showAlert(data.response,"");
        }
        else{
     
  
         window.open(data['url'], '_blank')
       
        }
      
       })
    }
  }
 


////// hidden recaptcha strat

loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey,  
      size: 'normal',  
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
     // console.log('Turnstile rendered successfully.');
  } else {
    // console.error('Turnstile script not loaded.');
  }
}

// Button click handler to execute Turnstile
handleButtonClick(): void {
  if (this.captchaToken) {
    

    this.got_recpatcha = false;
    this.continueforpayment()
  } else {
    this.got_recpatcha = true;
  
    swal({
      background: '#FFFFFF',
      title: 'Error',
      html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 11%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
          Captcha is not loaded. Please reload the page.
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class=" butn-alert">Ok</button>
          </div>
        </div>
      `,
      showConfirmButton: false,
      width: '323px',
      timer: 4000,
    });

  
    setTimeout(() => {
      const okButton = document.getElementById('swal-ok-button');
      if (okButton) {
        okButton.addEventListener('click', () => {
          swal.close(); 
        });
      }
    }, 0);

  }
}


onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token;  
}

// Error callback when CAPTCHA fails
onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}



  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;

  showAlert(message, selector) {


    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show'; 
        document.body.appendChild(backdrop); 
    }
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false; 
  }
  recaptchaScale = 'scale(1)';

  @HostListener('window:resize', ['$event'])
  onResize() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 320 && screenWidth <= 374) {
      this.recaptchaScale = 'scale(0.75)';
    } else if (screenWidth >= 375 && screenWidth <= 425) {
      this.recaptchaScale = 'scale(0.85)';
    } else if (screenWidth >= 426 && screenWidth <= 667) {
      this.recaptchaScale = 'scale(0.9)';
    } else if (screenWidth === 668) {
      this.recaptchaScale = 'scale(1)';
    }
    else if (screenWidth >= 992 && screenWidth <= 1399) {
      this.recaptchaScale = 'scale(0.75)';
    }
    else if (screenWidth > 1399) {
      this.recaptchaScale = 'scale(1)';
    }
    else {
      this.recaptchaScale = 'scale(1)';
    }
  }
}
